import { motion } from "framer-motion";
import { Shield, Zap, Settings, Sparkles, MessageSquare, Gauge } from "lucide-react";
import FeatureCard from "@/components/FeatureCard";
import { useI18n } from "@/contexts/I18nContext";

const FeaturesSection = () => {
  const { t } = useI18n();

  const features = [
    {
      icon: Shield,
      title: t('features.item.moderation.title'),
      description: t('features.item.moderation.desc'),
      gradient: "from-red-500 to-orange-500",
    },
    {
      icon: Zap,
      title: t('features.item.automation.title'),
      description: t('features.item.automation.desc'),
      gradient: "from-primary to-cyan-400",
    },
    {
      icon: MessageSquare,
      title: t('features.item.engagement.title'),
      description: t('features.item.engagement.desc'),
      gradient: "from-secondary to-pink-400",
    },
    {
      icon: Settings,
      title: t('features.item.config.title'),
      description: t('features.item.config.desc'),
      gradient: "from-slate-500 to-slate-400",
    },
    {
      icon: Sparkles,
      title: t('features.item.ai.title'),
      description: t('features.item.ai.desc'),
      gradient: "from-fuchsia-500 to-rose-500",
    },
    {
      icon: Gauge,
      title: t('features.item.analytics.title'),
      description: t('features.item.analytics.desc'),
      gradient: "from-emerald-500 to-green-400",
    },
  ];

  return (
    <section id="features" className="py-20 px-6 relative">
      <div className="container mx-auto max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="gradient-text">{t('features.titleAccent')}</span> {t('features.title')}
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            {t('features.subtitle')}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <FeatureCard
              key={feature.title}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
              gradient={feature.gradient}
              delay={index * 0.1}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
